module.exports = __webpack_public_path__ + "img/icon_map_0.481b7909.png";